import { render, staticRenderFns } from "./EZVideo.vue?vue&type=template&id=44324e5e&scoped=true"
import script from "./EZVideo.vue?vue&type=script&lang=js"
export * from "./EZVideo.vue?vue&type=script&lang=js"
import style0 from "./EZVideo.vue?vue&type=style&index=0&id=44324e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44324e5e",
  null
  
)

export default component.exports